import React from "react";
import { Form } from "react-bootstrap";
import { Box, Stack, Typography } from "@mui/material";
import { useCompactLayout } from "../../../../components/responsive";
import { LOG_ACTIONS, LOG_MODULES } from "./logReportDisplay";

export function LogReportToolbar({
  moduleFilter,
  actionFilter,
  dateFrom,
  dateTo,
  searchKey,
  onModuleChange,
  onActionChange,
  onDateFromChange,
  onDateToChange,
  onSearch,
  onExport,
}: {
  moduleFilter: string;
  actionFilter: string;
  dateFrom: string;
  dateTo: string;
  searchKey: string;
  onModuleChange: (value: string) => void;
  onActionChange: (value: string) => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onExport: () => void;
}) {
  const { containerRef, isCompact } = useCompactLayout();

  return (
    <Box ref={containerRef} sx={{ width: "100%", minWidth: 0, mb: 2 }}>
      <Stack
        direction={isCompact ? "column" : "row"}
        spacing={1}
        alignItems={isCompact ? "stretch" : "center"}
        justifyContent="space-between"
        sx={{ mb: 1.5, pb: 1.5, borderBottom: "1px solid #e5e7eb" }}
      >
        <Box>
          <Typography className="card-title mb-1" variant="h6" sx={{ mb: 0.5 }}>
            Log Report
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ m: 0 }}>
            Significant actions only. Entries older than 4 months are removed
            automatically.
          </Typography>
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          <button
            onClick={onExport}
            className="btn btn-primary btn-sm text-white mb-0 me-0 alignbtn export-approval-couple d-flex align-items-center gap-1"
            type="button"
          >
            <i className="mdi mdi-download me-1"></i> Export
          </button>
        </Box>
      </Stack>

      <Stack
        direction={isCompact ? "column" : "row"}
        spacing={1}
        alignItems={isCompact ? "stretch" : "center"}
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        sx={{ width: "100%", minWidth: 0 }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          sx={{ width: isCompact ? "100%" : "auto", minWidth: 0 }}
        >
          <Form.Select
            size="sm"
            value={moduleFilter}
            onChange={(e) => onModuleChange(e.target.value)}
            style={{ width: isCompact ? "100%" : 160 }}
          >
            <option value="">All modules</option>
            {LOG_MODULES.filter(Boolean).map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            size="sm"
            value={actionFilter}
            onChange={(e) => onActionChange(e.target.value)}
            style={{ width: isCompact ? "100%" : 150 }}
          >
            <option value="">All actions</option>
            {LOG_ACTIONS.filter(Boolean).map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </Form.Select>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              width: isCompact ? "100%" : "auto",
              "& .form-control": { minWidth: 0, flex: 1 },
            }}
          >
            <Form.Control
              type="date"
              size="sm"
              value={dateFrom}
              onChange={(e) => onDateFromChange(e.target.value)}
              style={{ width: isCompact ? undefined : 150 }}
            />
            <span className="text-muted small">to</span>
            <Form.Control
              type="date"
              size="sm"
              value={dateTo}
              onChange={(e) => onDateToChange(e.target.value)}
              style={{ width: isCompact ? undefined : 150 }}
            />
          </Stack>
        </Stack>

        <Box
          className="form-group content1"
          sx={{
            flex: isCompact ? "1 1 auto" : "0 0 240px",
            minWidth: 0,
            width: isCompact ? "100%" : 240,
            mb: "0 !important",
          }}
        >
          <div className="input-group setSearch">
            <input
              onChange={onSearch}
              type="text"
              className="form-control searchData"
              placeholder="Search..."
              aria-label="Search log report"
              value={searchKey}
            />
            <div className="input-group-append">
              <button className="btn btn-sm btn-primary" type="button">
                <i className="icon-search"></i>
              </button>
            </div>
          </div>
        </Box>
      </Stack>
    </Box>
  );
}
